import React from 'react'
import Alert from '@mui/material/Alert'
import WarningIcon from '@mui/icons-material/Warning'
import styled from '@mui/system/styled'

const StyledSecurityAlert = styled(Alert)(() => ({
  alignItems: 'center',
  backgroundColor: 'var(--warning-alternative)',
  borderRadius: 0,
  boxSizing: 'border-box',
  color: 'var(--color-light)',
  fontSize: 'var(--font-size-scale-base)',
  lineHeight: 'var(--font-lineheight-medium)',
  maxWidth: '100vw',
  padding: 'var(--spacing-scale-base) var(--spacing-scale-2x)',
  width: '100%',
  '& .MuiAlert-icon': {
    alignItems: 'center',
    color: 'var(--color-light)',
    marginRight: 'var(--spacing-scale-2x)',
    padding: 0
  },
  '& .MuiAlert-message': {
    minWidth: 0,
    overflowWrap: 'anywhere',
    padding: 0
  }
}))

const GovBrSecurityAlert = () => (
  <StyledSecurityAlert
    icon={<WarningIcon fontSize="inherit" />}
    role="alert"
    severity="warning"
  >
    <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
      <strong>Atenção:</strong>{' '}
      Nosso e-mail oficial de notificação é notificacao@atendimento.servicos.gov.br. Não solicitamos instalação de aplicativos para realizar atendimentos. Se você receber um e-mail pedindo para instalar um aplicativo ou clicar em um link, não faça. Em caso de dúvida, procure os canais oficiais do gov.br.
    </span>
  </StyledSecurityAlert>
)

export default GovBrSecurityAlert
